import { mapComment } from './comment';
import { TodoType } from './todo-type';


function mapTodo(todo) {
    const ret = {...todo};
    const details = mapTodoDetails(todo);
    Object.keys(details).forEach(key => {
        ret[key] = details[key];
    });
    if (ret.children && ret.children.length) {
        ret.children = ret.children.map(mapTodo);
    }
    return ret;
}

function mapTodoDetails(todo) {
    let ret = { ...todo }; 

    if (!ret) {
        return ret;
    }

    if (ret.comments) {
        ret = {
            ...ret,
            comments: ret.comments.map(mapComment)
        };
    }

    if (typeof ret.createdOn === 'string' && ret.createdOn) {
        ret = {
            ...ret,
            createdOn: new Date(ret.createdOn)
        };
    }

    if (typeof ret.lastModified === 'string' && ret.lastModified) {
        ret = {
            ...ret,
            lastModified: new Date(ret.lastModified)
        };
    }

    if (typeof ret.snoozedUntil === 'string' && ret.snoozedUntil) {
        ret = {
            ...ret,
            snoozedUntil: new Date(ret.snoozedUntil)
        };
    }

    if (typeof ret.dueDate === 'string' && ret.dueDate) {
        ret = {
            ...ret,
            dueDate: new Date(ret.dueDate)
        };
    }

    if (typeof ret.notificationDate === 'string' && ret.notificationDate) {
        ret = {
            ...ret,
            notificationDate: new Date(ret.notificationDate)
        };
    }

    if (
        ret.notificationConfig &&
        ret.notificationConfig.absoluteDate &&
        typeof ret.notificationConfig.absoluteDate === 'string' &&
        ret.notificationConfig.absoluteDate
    ) {
        ret = {
            ...ret,
            notificationConfig: {
                ...ret.notificationConfig,
                absoluteDate: new Date(ret.notificationConfig.absoluteDate)
            }
        };
    }

    return ret;
}


function narrowToDetails(todo) {
    return {
        color: todo.color,
        comments: todo.comments,
        createdOn: todo.createdOn,
        description: todo.description,
        dueDate: todo.dueDate,
        id: todo.id,
        isCompleted: todo.isCompleted,
        isSnoozed: todo.isSnoozed,
        lastModified: todo.lastModified,
        snoozedUntil: todo.snoozedUntil,
        title: todo.title,
        type: todo.type,
        visualSize: todo.visualSize,
        siblingOrder: todo.siblingOrder,
        globalPriority: todo.globalPriority,
        notificationConfig: todo.notificationConfig,
        notificationDate: todo.notificationDate,
        recurrencePatternId: todo.recurrencePatternId
    };
}

function hasGlobalPriority(todo) {
    return todo.type === TodoType.task && (todo.globalPriority || todo.globalPriority === 0);
}

export {
    mapTodo,
    mapTodoDetails,
    narrowToDetails,
    hasGlobalPriority
};
